import { Box, Stack, Typography } from '@mui/joy'
import React from 'react'
import { calculateRatePerMile } from 'utils/load-helpers/helpers'
import { RateColumnProps } from './types'

/**
 * RateColumn component displays rate information when the load row is expanded.
 * This includes:
 * - Total rate
 * - Trip length
 * - Rate/Mile
 * - Email Form (if email is available)
 */

export const RateColumn: React.FC<RateColumnProps> = ({ load }) => {
    if (!load.rateInfo?.rateUsd && !load.posterInfo.contact?.email) return null

    const renderRatePart = () => {
        if (!load.rateInfo?.rateUsd) return null

        return (
            <>
                <Typography
                    sx={{
                        color: 'text.secondary',
                        backgroundColor: 'background.surface',
                        px: 1,
                        fontWeight: 'bold',
                    }}
                >
                    Rate
                </Typography>
                <Stack direction={{ sm: 'column', md: 'row' }} justifyContent={'space-between'} px={1}>
                    <Stack direction={'row'} gap={1}>
                        <Typography
                            level="body-sm"
                            sx={{
                                fontSize: '0.8rem',
                            }}
                        >
                            Total Rate:
                        </Typography>
                        <Typography
                            level="body-sm"
                            sx={{
                                fontSize: '0.8rem',
                            }}
                        >
                            ${load.rateInfo.rateUsd.toLocaleString()}
                        </Typography>
                    </Stack>
                    <Stack direction={'row'} gap={1}>
                        <Typography
                            level="body-sm"
                            sx={{
                                fontSize: '0.8rem',
                            }}
                        >
                            Rate/Mile:
                        </Typography>
                        <Typography
                            level="body-sm"
                            sx={{
                                fontSize: '0.8rem',
                            }}
                        >
                            {load.rateInfo.ratePerMileUsd
                                ? `$${Number(load.rateInfo.ratePerMileUsd).toFixed(2)}/mi`
                                : load.tripLength && load.rateInfo.rateUsd
                                  ? calculateRatePerMile(load.tripLength, load.rateInfo.rateUsd)
                                  : '—'}
                        </Typography>
                    </Stack>
                </Stack>
            </>
        )
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                width: '100%',
            }}
        >
            {renderRatePart()}
        </Box>
    )
}
